import { c as _c } from "react/compiler-runtime";
import { Select, Tag } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Subsection from '../../../../../subsection';
import type { FormattedWatchlist } from '../../../../onboarding-business-insight.types';
import AmlHitsList from './components/aml-hits-list';
import HitsList from './components/hits-list';
type WatchlistProps = {
  data: FormattedWatchlist;
};
const Watchlist = t0 => {
  const $ = _c(29);
  const {
    data: t1
  } = t0;
  const {
    watchlist
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "onboardings.watchlist"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  let t3;
  if ($[1] !== watchlist) {
    t3 = Object.keys(watchlist).length ? Object.keys(watchlist)[0] : undefined;
    $[1] = watchlist;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [selectedEntityKey, setSelectedEntityKey] = useState(t3);
  const selectedEntity = selectedEntityKey ? watchlist[selectedEntityKey] : undefined;
  let t4;
  if ($[3] !== watchlist) {
    t4 = Object.entries(watchlist).map(_temp);
    $[3] = watchlist;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const options = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = value => {
      setSelectedEntityKey(value);
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleChange = t5;
  if (!selectedEntity) {
    let t6;
    if ($[6] !== t) {
      t6 = t(_temp2);
      $[6] = t;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    let t7;
    if ($[8] !== t6) {
      t7 = <Subsection><span className="text-body-2 text-tertiary">{t6}</span></Subsection>;
      $[8] = t6;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    return t7;
  }
  const t6 = selectedEntityKey ?? "";
  let t7;
  if ($[10] !== options || $[11] !== t6) {
    t7 = <div className="w-full md:contents"><Select className="w-full md:w-[300px] border-tertiary" onChange={handleChange} options={options} size="compact" value={t6} /></div>;
    $[10] = options;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== selectedEntity.kind || $[14] !== t) {
    t8 = selectedEntity.kind === "business" ? t(_temp3) : t(_temp4);
    $[13] = selectedEntity.kind;
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <Tag>{t8}</Tag>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t9) {
    t10 = <div className="flex flex-wrap items-center gap-2 md:flex-nowrap md:gap-4">{t7}{t9}</div>;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== selectedEntity.hits || $[22] !== selectedEntity.screenedEntityName || $[23] !== selectedEntity.shareUrl || $[24] !== selectedEntity.source) {
    t11 = selectedEntity.source === "aml" ? <AmlHitsList hits={selectedEntity.hits} shareUrl={selectedEntity.shareUrl} /> : <HitsList name={selectedEntity.screenedEntityName} hits={selectedEntity.hits} />;
    $[21] = selectedEntity.hits;
    $[22] = selectedEntity.screenedEntityName;
    $[23] = selectedEntity.shareUrl;
    $[24] = selectedEntity.source;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11) {
    t12 = <Subsection><div className="flex flex-col gap-4">{t10}{t11}</div></Subsection>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
export default Watchlist;
function _temp(t0) {
  const [entityKey, entity] = t0;
  return {
    label: entity.screenedEntityName,
    value: entityKey
  };
}
function _temp2($) {
  return $.emptyState;
}
function _temp3($_0) {
  return $_0.tags.business;
}
function _temp4($_1) {
  return $_1.tags.person;
}